var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-html", attrs: { id: "login-html" } },
    [
      _c(
        "div",
        { staticClass: "login-box" },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-column align-items-center" },
            [
              _c("b-img", { attrs: { src: _vm.logo_company, height: "164" } }),
              _vm._v(" "),
              _c("p", { staticClass: "login-title m__t--20" }, [
                _vm._v("Sign in to your account")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form",
            {
              on: {
                reset: _vm.onReset,
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key)
                  ) {
                    return null
                  }
                  _vm.onSubmit($event)
                }
              }
            },
            [
              _c(
                "b-form-group",
                [
                  _c("b-form-input", {
                    class: { "error-input": _vm.$v.form.email.$error },
                    staticStyle: { border: "1px solid #D0D0D0" },
                    attrs: {
                      id: "exampleInput1",
                      "error-message": null,
                      placeholder: "Email Address",
                      type: "email"
                    },
                    model: {
                      value: _vm.$v.form.email.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.form.email, "$model", $$v)
                      },
                      expression: "$v.form.email.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                { attrs: { id: "passwordInput" } },
                [
                  _c("b-form-input", {
                    class: { "error-input": _vm.$v.form.password.$error },
                    staticStyle: { border: "1px solid #D0D0D0" },
                    attrs: {
                      id: "exampleInput2",
                      type: _vm.password_id,
                      "error-message": null,
                      placeholder: "Password"
                    },
                    model: {
                      value: _vm.$v.form.password.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.form.password, "$model", $$v)
                      },
                      expression: "$v.form.password.$model"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", [
                    _c("i", {
                      class: {
                        "fa fa-eye": !_vm.show_pass,
                        "fa fa-eye-slash": _vm.show_pass
                      },
                      attrs: { role: "img" },
                      on: {
                        click: function($event) {
                          _vm.show_pass = !_vm.show_pass
                        }
                      }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _vm.captcha_login
                ? _c("vue-recaptcha", {
                    ref: "recaptcha",
                    staticClass: "g-recaptcha",
                    attrs: {
                      "load-recaptcha-script": true,
                      sitekey: _vm.sitekey
                    },
                    on: {
                      verify: _vm.onCaptchaVerified,
                      expired: _vm.onCaptchaExpired
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-col",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "b-button",
                        {
                          class: {
                            disabled:
                              _vm.$v.form.$invalid ||
                              (_vm.captcha_login &&
                                (!_vm.recaptchaToken || !_vm.publicKey))
                          },
                          attrs: {
                            id: "btn-login",
                            disabled: _vm.$v.form.$invalid
                          },
                          on: { click: _vm.onSubmit }
                        },
                        [_vm._v("\n            Login\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.withLDAP
            ? _c(
                "div",
                { staticClass: "other-signin" },
                [
                  _c("p", [_vm._v("Or")]),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "btn-active-directory",
                      attrs: { to: "/signin-with-ldap" }
                    },
                    [
                      _vm._v("\n        Sign in with "),
                      _c("span", [_vm._v("Active Directory")])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "login-copy" }, [
        _c("p", [_vm._v("Version " + _vm._s(_vm.version_code))]),
        _vm._v(" "),
        _c(
          "p",
          [
            _vm._v("Powered by\n      "),
            _c(
              "b-link",
              {
                attrs: { href: "https://officeless.studio/", target: "_blank" }
              },
              [_c("strong", [_vm._v("Jojonomic")])]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "j-modal",
        { ref: "modalOtp" },
        [
          _c("input-otp", {
            attrs: {
              "otp-show": _vm.otp_show,
              "wait-time": _vm.data_otp
                ? _vm.data_otp.expired_millisecond
                : 12909309,
              mode: "login"
            },
            on: { "close-modal": _vm.hideOtpModal }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a929e5c2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a929e5c2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/jLogin.vue
// module id = null
// module chunks = 